<button class="productDetails__authentication vc-body3" (click)="openAuthenticationModal()">
  <vc-sprite-icons name="authentication" class="productDetails__authentication__icon"></vc-sprite-icons>
  <p>
    <ng-container i18n="@@PRODUCT.DETAILS.BUYER_FEES.REASSURANCE">
      Verified and authenticated by our experts</ng-container
    >&nbsp;
    <span class="productDetails__authentication__knowMore" i18n="@@PRODUCT.DETAILS.BUYER_FEES.MORE_INFOS"
      >More infos</span
    >
  </p>
</button>
